import { getHttp } from './fetchApi';

export const Topics = {
    URL: '/topics.json',
    getAll(){
        return getHttp(this.URL)
    },

}
